import type React from 'react';

import { AvailableIcon, isAvailableNow, useAvailablePeriod } from '@entities/available-periods';
import { useTz } from '@entities/schedules';
import cn from 'classnames';

import { getSessionBlock } from '@shared/helpers';

import { StartTime } from '../start-time';
import * as st from './styles.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
	start: Date;
	end: Date;
	availableId: number;
}

export const AvailableSession: React.FC<Props> = ({ start, end, availableId, ...props }) => {
	const { availablePeriod } = useAvailablePeriod(availableId);
	const { tz } = useTz();
	const blockType = getSessionBlock(
		{
			start,
			end,
		},
		tz,
		availablePeriod?.start_time,
		availablePeriod?.end_time
	);

	const isNow = isAvailableNow(availablePeriod);

	return (
		<div className={cn(st.session, st[blockType], isNow && st.now)} {...props}>
			{(blockType === 'start' || blockType === 'start_topOverlap' || blockType === 'single') && (
				<>
					<StartTime start={availablePeriod?.start_time} />
					<AvailableIcon id={availableId} />
				</>
			)}
		</div>
	);
};
